module.exports = __webpack_public_path__ + "static/img/stay-option-icon-laptop.2472987c.svg";